import Hash from '../../lib/hash';

import * as Map from './drawing';

class Element {
	constructor(container) {
		this.container = container;

		this.google_map = new google.maps.Map(this.container, {
			zoom: 1,
			center: new google.maps.LatLng({ lat: 0, lng: 0 }),
			mapTypeControl: false,
			streetViewControl: false,
			clickableIcons: false
		});

		this.container.map_object = this;

		this._markers = new Hash();
		this.geo_points = {};

		const markers_data = this.container.dataset.markers;
		this.markers_data = Object.assign(
			{ zoom: 16, draggable: false },
			markers_data ? JSON.parse(markers_data) : {}
		);

		// Drawing

		let drawing_data = this.container.dataset.drawing;

		if (drawing_data) {
			drawing_data = JSON.parse(drawing_data);

			if (this.container.dataset.isGeometry) {
				this.google_map.data.addGeoJson(
					drawing_data['existing_data'], { idPropertyName: 'id' }
				);
				this.google_map.data.setStyle(this.featureStyle);

				drawing_data['existing_data'] = [];
			}

			this._drawing = new Map.Drawing(this, drawing_data);
		}

		this.zoom_to_objects();
	}

	featureStyle(feature) {
		let color = '#ffffff';
		switch (feature.h.priority) {
			case 2: color = '#FFA500'; break;
			case 3: color = '#FF0000'; break;
		}
		return {
			strokeColor: color,
			fillColor: color
		};
	}

	update_marker(label, position) {
		if (!this._markers.get(label)) {
			this._markers.add(
				label,
				new google.maps.Marker({
					map: this.google_map,
					label: label,
					draggable: this.markers_data.draggable,
					clickable: this.markers_data.draggable
				})
			);

			if (this.markers_data.draggable) {
				this._markers.get(label).addListener('dragstart', () => {
					const geo_point = this.geo_points[label];

					// Renew the flag
					this.marker_dragging = true;

					// Stop requests for inputs
					for (const key in this.geo_points) {
						this.geo_points[key].clear_update_timeouts();
					}

					// Clear inputs
					geo_point.clear_inputs();

					// Clear directions
					if (geo_point.directions) geo_point.directions.clear();
				});

				this._markers.get(label).addListener('dragend', () => {
					// Renew the flag
					this.marker_dragging = false;

					// Update inputs with new coordinates
					this.geo_points[label].update_address(
						this._markers.get(label).getPosition(),
						{ correction: true }
					);
					// this._update_directions({ clean_before: false });
				});
			}
		}

		this._markers.get(label).setOptions(
			(() => {
				if (position) {
					return { map: this.google_map, position: position };
				} else {
					return { map: null };
				}
			})()
		);

		this.zoom_to_objects();
	}

	zoom_to_objects() {
		const markers = this._markers.filter(
			(label, marker) => marker.getMap()
		);

		const polygons = this._drawing ? this._drawing.polygons : [];

		if (markers.length() > 1 || polygons.length > 0) {

			let bounds = new google.maps.LatLngBounds();

			markers.each((label, marker) => {
				bounds.extend(marker.getPosition());
			});

			polygons.forEach(polygon => {
				polygon.polygon.getPath().forEach(latLng => {
					bounds.extend(latLng);
				});
			});

			this.google_map.data.forEach(feature =>
				feature.getGeometry()
					.forEachLatLng(latLng => bounds.extend(latLng)));

			this.google_map.fitBounds(bounds);

		} else if (markers.length() == 1 && polygons.length < 1) {

			this.google_map.setZoom(this.markers_data.zoom);
			this.google_map.panTo(markers.first().getPosition());

		}
	}
}

export { Element };
